import { fetchBoard, type Board } from '../net/api';
import type { GameDef } from '../games/registry';
import type { Player } from '../player';
import { el } from './dom';

export function renderBoard(root: HTMLElement, game: GameDef, player: Player, nav: { back(): void; play(): void }): () => void {
  const list = el('ol', { class: 'board-list' });
  const status = el('p', { class: 'dim center' }, 'Loading…');
  const wrap = el(
    'section',
    { class: 'page board' },
    el('header', { class: 'page-top' }, el('button', { class: 'icon-btn', type: 'button', 'aria-label': 'back', onclick: nav.back }, '‹'), el('h1', {}, `${game.icon} ${game.title}`), el('button', { class: 'icon-btn', type: 'button', 'aria-label': 'refresh', onclick: () => void load() }, '↻')),
    el('p', { class: 'dim center' }, `best ${game.scoreLabel} per player`),
    status,
    list,
    el('div', { class: 'page-actions' }, el('button', { class: 'btn primary big', type: 'button', onclick: nav.play }, 'Play')),
  );
  root.append(wrap);

  function row(rank: number, name: string, score: number, mistakes: number, at: number, me: boolean): HTMLElement {
    const when = new Date(at * 1000);
    return el(
      'li',
      { class: 'board-row' + (me ? ' me' : '') },
      el('span', { class: 'rank' }, rank <= 3 ? ['🥇', '🥈', '🥉'][rank - 1] : `${rank}`),
      el('span', { class: 'name' }, name, me ? el('small', {}, ' (you)') : null),
      el('span', { class: 'score' }, game.formatScore(score)),
      el('small', { class: 'meta' }, `${mistakes} ✕ · ${when.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}`),
    );
  }

  async function load(): Promise<void> {
    status.textContent = 'Loading…';
    status.hidden = false;
    list.replaceChildren();
    const board: Board | null = await fetchBoard(game.id, player.id, 25);
    if (!board) {
      status.textContent = 'Could not reach the leaderboard. Are you online?';
      return;
    }
    if (!board.entries.length) {
      status.textContent = 'No one yet. Be the first!';
      return;
    }
    status.hidden = true;
    board.entries.forEach((e, i) => list.append(row(i + 1, e.name, e.score, e.mistakes, e.at, e.player === player.id)));
    if (board.me && board.me.rank > board.entries.length) {
      list.append(el('li', { class: 'board-gap' }, '…'));
      list.append(row(board.me.rank, player.name || 'you', board.me.best, 0, Date.now() / 1000, true));
    }
  }
  void load();
  return () => wrap.remove();
}
